const AdministratorsTypes = {
  SET_ADMINISTRATORS_LOADING: 'ADMINISTRATORS/SET_ADMINISTRATORS_LOADING',
  SET_ADMINISTRATORS_FAILURE: 'ADMINISTRATORS/SET_ADMINISTRATORS_FAILURE',
  SET_ADMINISTRATORS_SUCCESS: 'ADMINISTRATORS/SET_ADMINISTRATORS_SUCCESS',
};

export default AdministratorsTypes;